import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BroadcastService } from '@azure/msal-angular';
import { LoginAwareComponent } from '../login-aware-component';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Top and main navigation menu. Certain links are only shown to authenticated users.
 */
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  isExpanded = false;
  userInfo: any;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    authService: MsalService,
    broadcastService: BroadcastService) {
    super(diagnosticsFactory.create('NavMenuComponent'), broadcastService, authService);
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
